import {Component, Input} from '@angular/core';
import {User} from "../../auth/primitives/user";
import {Message, Participant} from "../../state/chats/chat.model";
import moment from "moment";
import {NgIf} from "@angular/common";
import {FaIconComponent, IconDefinition} from "@fortawesome/angular-fontawesome";
import {IconsService} from "../../services/icons.service";

@Component({
  selector: 'chat-message',
  standalone: true,
  imports: [
    NgIf,
    FaIconComponent,
  ],
  templateUrl: './chat-message.component.html',
  styleUrl: './chat-message.component.scss'
})
export class ChatMessageComponent  {

  pParticipants: Participant[] = []
  pUser: User = null

  seenIcon: IconDefinition
  seen = false

  @Input()
  set user(user: User) {
    this.pUser = user
    this.checkForSeen()
  }

  @Input()
  isMe: boolean = false

  @Input()
  set participants(participants: Participant[]) {
    this.pParticipants = participants
    this.checkForSeen()
  }

  @Input()
  fileId?: string = null

  @Input()
  imageBase64?: string = null

  @Input()
  set message(msg: Message) {
    this.pMessage = msg
    this.updateTime()
    this.fontSize = this.fontSizeForLength(this.pMessage.text)
    if ((msg as any).isFirstOfDay) {
       // = moment(msg.created_at).format('dddd, MMMM Do YYYY')
      this.displayDate = moment(msg.created_at).calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: '[Yesterday]',
        lastWeek: 'ddd, D MMM',
        sameElse: 'D MMM YYYY'
      });
    }
    this.sameAuthor = (msg as any).sameAuthor
  }

  pMessage: Message = null
  fontSize: string = "1rem"
  displayTime: string = ""

  displayDate: string = null
  sameAuthor = false

  constructor(
      private iconsService: IconsService
  ) {
    this.seenIcon =  this.iconsService.faIconsRegular.faCircle
  }

  checkForSeen() {
    if (!this.pParticipants) return
    if (!this.pUser) return
    for (const participant of this.pParticipants) {
      if (participant.participant_id === this.pUser.id) continue
      if ((new Date(participant.last_seen_at)).getTime() >= (new Date(this.pMessage.created_at)).getTime()) {
        this.seen = true
        this.seenIcon = this.iconsService.faIconsSolid.faCircle
      }
    }
  }

  updateTime() {
    this.displayTime = moment(this.pMessage.created_at)
        .format('h:mm a'); // January 18th 2026, 12:59:37 am
  }

  fontSizeForLength(input: string): string {
    const len = input.length;
    if (len <= 1) return '4rem';
    if (len <= 3) return '2rem';
    if (len <= 10) return '1.2rem';
    return '1rem';
  }

}
